"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
exports.__esModule = true;
var React = require("react");
var styled_components_1 = require("styled-components");
exports.SituationSelector = function (_a) {
    var options = _a.options, selected = _a.selected, label = _a.label, onChange = _a.onChange;
    return (React.createElement(StyledSituationSelector, null,
        React.createElement("div", null, label),
        React.createElement(StyledSelect, { value: selected, onChange: onChange, disabled: options.length === 0 },
            React.createElement("option", { key: "", value: "" }, options.length > 0 ? "未選択" : "選択できません"),
            options.map(function (option) {
                if ("id" in option) {
                    return (React.createElement("option", { key: option.id, value: option.id }, option.name));
                }
                var group = option;
                return (React.createElement("optgroup", { key: option.name, label: option.name },
                    group.options.map(function (o) {
                        return (React.createElement("option", { key: o.id, value: o.id }, o.name));
                    }),
                    ";"));
            }))));
};
var StyledSituationSelector = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 8px 0;\n"], ["\n  padding: 8px 0;\n"])));
var StyledSelect = styled_components_1["default"].select(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block;\n  padding: 4px 2px;\n  width: 100%;\n  font-size: 14px;\n  font-weight: 700;\n"], ["\n  display: block;\n  padding: 4px 2px;\n  width: 100%;\n  font-size: 14px;\n  font-weight: 700;\n"])));
var templateObject_1, templateObject_2;
